import React from "react";
import { Box, Grid } from "@mui/material";
import CustomTextField from "../commoncomponents/CustomTextField";
import utilities from "../../utility/utilities";
import { validations } from "../../utility/constants/errors/messages";

const VendorAddress = ({
  address1,
  address2,
  state,
  postcode,
  country,
  errors,
  errorMessages,
  setAddress1,
  setAddress2,
  setState,
  setCountry,
  setPostcode,
  setErrors,
  setErrorMessages,
  isView,
  setIsChanged,
}) => {
  const handleAddress1Change = (newvalue) => {
    setIsChanged(true);
    setAddress1(newvalue);
    if (newvalue) {
      setErrors((prev) => ({ ...prev, address1: false }));
      setErrorMessages((prev) => ({ ...prev, address1: "" }));
    }
    if (utilities.validateTextFieldCodeforAddress(newvalue) || !newvalue) {
      setErrors((prev) => ({ ...prev, address1: false }));
      setErrorMessages((prev) => ({ ...prev, address1: "" }));
    } else if (!utilities.validateTextFieldCodeforAddress(newvalue)) {
      setErrors((prev) => ({ ...prev, address1: true }));
      setErrorMessages((prev) => ({
        ...prev,
        address1: validations.textfield,
      }));
    }
  };

  const handleAddress2Change = (newValue) => {
    setIsChanged(true);
    setAddress2(newValue);
  
    if (newValue.trim() === "") {
      setErrors((prev) => ({ ...prev, address2: false }));
      setErrorMessages((prev) => ({ ...prev, address2: "" }));
      return;
    }
  
    if (utilities.validateTextFieldCodeforAddress(newValue)) {
      setErrors((prev) => ({ ...prev, address2: false }));
      setErrorMessages((prev) => ({ ...prev, address2: "" }));
    } else {
      setErrors((prev) => ({ ...prev, address2: true }));
      setErrorMessages((prev) => ({
        ...prev,
        address2: validations.textfield,
      }));
    }
  };
  const handleStateChange = (newvalue) => {
    setIsChanged(true);
    setState(newvalue);
    if (newvalue) {
      setErrors((prev) => ({ ...prev, state: false }));
      setErrorMessages((prev) => ({ ...prev, state: "" }));
    }
    if (utilities.validateTextField(newvalue) || !newvalue) {
      setErrors((prev) => ({ ...prev, state: false }));
      setErrorMessages((prev) => ({ ...prev, state: "" }));
    } else if (!utilities.validateTextField(newvalue)) {
      setErrors((prev) => ({ ...prev, state: true }));
      setErrorMessages((prev) => ({
        ...prev,
        state: validations.textfield,
      }));
    }
  };
  const handlePostcodeChange = (newvalue) => {
    setIsChanged(true);
    setPostcode(newvalue);
    if (newvalue) {
      setErrors((prev) => ({ ...prev, postcode: false }));
      setErrorMessages((prev) => ({ ...prev, postcode: "" }));
    }
    if (utilities.validateTextField(newvalue) || !newvalue) {
      setErrors((prev) => ({ ...prev, postcode: false }));
      setErrorMessages((prev) => ({ ...prev, postcode: "" }));
    } else if (!utilities.validateTextField(newvalue)) {
      setErrors((prev) => ({ ...prev, postcode: true }));
      setErrorMessages((prev) => ({
        ...prev,
        postcode: validations.textfield,
      }));
    }
  };
  const handleCountryChange = (newvalue) => {
    setIsChanged(true);
    setCountry(newvalue);
    if (newvalue) {
      setErrors((prev) => ({ ...prev, country: false }));
      setErrorMessages((prev) => ({ ...prev, country: "" }));
    }
    if (utilities.validateTextField(newvalue) || !newvalue) {
      setErrors((prev) => ({ ...prev, country: false }));
      setErrorMessages((prev) => ({ ...prev, country: "" }));
    } else if (!utilities.validateTextField(newvalue)) {
      setErrors((prev) => ({ ...prev, country: true }));
      setErrorMessages((prev) => ({
        ...prev,
        country: validations.textfield,
      }));
    }
  };

  return (
    <>
      <Grid item xs={6} md={4} sx={{ display: "flex",alignItems: "center" }}>
        <Box width={"100%"}>
          <CustomTextField
            label={"Address1"}
            isMandatoryField={true}
            maxlength={60}
            value={address1}
            error={errors.address1}
            helperText={errorMessages.address1}
            onChange={handleAddress1Change}
            disabled={isView}
          />
        </Box>
      </Grid>
      <Grid item xs={6} md={4}>
        <CustomTextField
          label={"Address2"}
          maxlength={60}
          error={errors.address2}
          helperText={errorMessages.address2}
          value={address2}
          onChange={handleAddress2Change}
          disabled={isView}
        />
      </Grid>
      <Grid item xs={6} md={4}>
        <CustomTextField
          label={"State"}
          isMandatoryField={true}
          maxlength={50}
          error={errors.state}
          helperText={errorMessages.state}
          value={state}
          onChange={handleStateChange}
          disabled={isView}
        />
      </Grid>
      <Grid item xs={6} md={4}>
        <CustomTextField
          label={"Country"}
          isMandatoryField={true}
          error={errors.country}
          helperText={errorMessages.country}
          maxlength={50}
          onChange={handleCountryChange}
          value={country}
          disabled={isView}
        />
      </Grid>
      <Grid item xs={6} md={4}>
        <CustomTextField
          label={"Postcode"}
          isMandatoryField={true}
          maxlength={10}
          errorMessage={errorMessages.postcode}
          error={errors.postcode}
          helperText={errorMessages.postcode}
          onChange={handlePostcodeChange}
          value={postcode}
          disabled={isView}
        />
      </Grid>
    </>
  );
};

export default VendorAddress;
